import { IAmexData, IPayData, IVPlusData } from "@/entities";
import { filenameToContentType } from "@aws-amplify/core";
import { Module } from "vuex";

import {
    IActions,
    IOrderState,
    IGetters,
    IMutations,
} from "./order.types"

export const getters: IGetters = {
    loading: (state) => {
        return state.loading;
    }
}

export const mutations: IMutations = {
    setLoading: (state, payload) => {
        state.loading = payload;
    }
}

export const actions: IActions = {
    async payByCreditCard(this, context, payload): Promise<IPayData | undefined> {
        try {
            context.commit("setLoading", true);
            const result = await this.$services.pay.payByCreditCard(payload);
            return result;

        }
        catch (error) {
            console.warn(error);
        }
        finally {
            context.commit("setLoading", false);
        }
    },
    async payByOther(this, context, payload): Promise<IPayData | undefined> {
        try {
            context.commit("setLoading", true);
            const result = await this.$services.pay.payByOther(payload);
            return result;

        }
        catch (error) {
            console.warn(error);
        }
        finally {
            context.commit("setLoading", false);
        }
    },
    async payByAmex(this, context, payload): Promise<IAmexData | undefined> {
        try {
            context.commit("setLoading", true);
            const result = await this.$services.pay.payByAmex(payload);
            return result;
        }
        catch (error) {
            console.warn(error);
        }
        finally {
            context.commit("setLoading", false);
        }
    },
    async configureAmex(this): Promise<unknown> {
        return this.$services.pay.configureAmexScript();
    },
    async payByAmexV2(this, context, payload): Promise<IAmexData | undefined> {
        try {
            context.commit("setLoading", true);
            const result = await this.$services.pay.payByAmexV2(payload.orderId, payload.amount);
            return result;
        }
        catch (error) {
            console.warn(error);
        }
        finally {
            context.commit("setLoading", false);
        }
    },
    async configureAmexV2(this): Promise<unknown> {
        return this.$services.pay.configureAmexV2Script();
    },
    async configureMastercardCard(this): Promise<unknown> {
        return this.$services.pay.configureMastercardCardScripts();
    },
    async payByWallet(this, context, payload): Promise<IVPlusData | undefined> {
        try {
            context.commit("setLoading", true);
            const result = await this.$services.pay.payByVplus(payload.orderId, payload.mobile);
            return result;
        }
        catch (error) {
            console.warn(error);
        }
        finally {
            context.commit("setLoading", false);
        }
    }
}

const order: Module<IOrderState, IOrderState> = {
    namespaced: true,
    state: {
        loading: false,
    },
    getters,
    mutations,
    actions,
};

export default order;